import _moment from "../../libs/moment"
export default (context) => {
  return {
    config: {
      pageSize: 40,
      list: false,
    },

    actions: {
      create: false,
      edit: false,
      delete: true,
      print: true,
      export: true,
      search: true
    },

    filter: {
      fields: [
        {
          name: "day",
          value: _moment().format("YYYY-MM-DD"),
          type: "date",
          label: "main.date",
          opts: {
            style: 'float-label'
          }
        },
        {
          name: "superSectionId",
          value: null,
          type: "select",
          label: "main.grade",
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true"
          }
        },
        {
          name: "sectionId",
          value: "",
          type: "select",
          label: "main.section",
          parent: "superSectionId",
          opts: {
            style: 'float-label',
            path: () => { return "/admSection/get?pick=true&parentId=" + context.state.formFilter.superSectionId }
          }
        }
      ],
      buttons: [
        {
          name: "btnFilter",
          label: "main.applyFilter",
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    columns: [
      {
        Header: "main.externalId",
        accessor: "externalId"
      },
      {
        Header: `main.lastName`,
        accessor: "last",
      },
      {
        Header: "main.name",
        accessor: "name",
      },
      {
        Header: "main.grade",
        accessor: "supersectionName",
      },
      {
        Header: "main.section",
        accessor: "sectionName"
      },
      {
        Header: "main.usualDeparture",
        accessor: "pickupTypeName"
      },
      {
        Header: "main.exeption",
        accessor: "pickupExcepTypeName"
      },
      {
        Header: "main.change",
        accessor: "pickupExcepNote"
      },
      {
        Header: "main.time",
        accessor: "pickupExcepTime"
      }
    ]
  }
}